export * from './fetch-brand-config';
